<script lang="ts">
    import { _ } from 'svelte-i18n';
    // https://svelte.dev/repl/4c5dfd34cc634774bd242725f0fc2dab?version=3.46.4
    import { clickOutside } from '../../utilities/clickOutside.js';

    import IconDropdown from '../../shared/Icons/IconDropdown.svelte';
    import IconMoreVert from '../../shared/Icons/IconMoreVert.svelte';
    import { Navigation } from '../../utilities/Navigation';
    import { features } from '../../shared/Features/features';
    import { canWrite } from '../../shared/Permissions/writeAccess';

    let isDropdownOpen: boolean = false; // default state (dropdown close)

    export let visibleOptions: ('upload-file' | 'manual-add-job' | 'manual-add-connection')[] = [
        'upload-file',
        'manual-add-job',
        'manual-add-connection',
    ];

    // wszystkie pozycje tego menu prowadzą do stron wyłącznie edycyjnych, więc dla konta
    // read-only nie ma czego pokazywać - całe menu znika razem z nimi
    $: availableOptions = $canWrite ? visibleOptions : [];

    const handleDropdownClick = () => {
        console.log('handleDropdownClick');
        isDropdownOpen = !isDropdownOpen; // togle state on click
    };

    const handleClickOutside = () => {
        isDropdownOpen = false;
    };
</script>

{#if availableOptions.length > 0}
<div class="menu-dropdown-container">
    <div
        class="dropdown"
        class:clickable={true}
        use:clickOutside
        on:click_outside={handleClickOutside}
    >
        <IconMoreVert on:click={handleDropdownClick} scale={0.7} />
        {#if isDropdownOpen}
            <div
                class="menu-list"
                style:visibility={isDropdownOpen ? 'visible' : 'hidden'}
                autofocus
            >
                {#if availableOptions.includes('upload-file')}
                    <button
                        class="button"
                        on:click={() => {
                            isDropdownOpen = false;
                            Navigation.navigate('/upload-file');
                        }}
                    >
                        {$_('Upload file')}
                    </button>
                {/if}
                {#if availableOptions.includes('manual-add-job')}
                    <button
                        class="button"
                        on:click={() => {
                            isDropdownOpen = false;
                            Navigation.navigate('/manual-add-job');
                        }}
                    >
                        {$_('Add job manually')}
                    </button>
                {/if}
                {#if availableOptions.includes('manual-add-connection')}
                    <button
                        class="button"
                        on:click={() => {
                            isDropdownOpen = false;
                            Navigation.navigate('/manual-add-connection');
                        }}
                    >
                        {$_('Manual add route')}
                    </button>
                {/if}
            </div>
        {/if}
    </div>
</div>
{/if}

<style>
    :root {
        --menu-background: #6c6b6a;
        --menu-color: #ffffff;
    }
    .menu-dropdown-container {
        position: relative;
        /*position: relative;*/
        /*z-index: 100;*/
        /*z-index: 1000;*/
    }
    .menu-list {
        z-index: 5;
        padding: 8px;
        background-color: white;
        color: black;
        border-radius: 6px;
        font-size: 13px;
        position: absolute;
        right: 0;
        /*left: 0;*/
        top: 35px;
        box-shadow: -1px 11px 31px -10px rgba(0, 0, 0, 0.75);
        min-width: 130px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        row-gap: 6px;
    }
    .menu-list button {
        list-style: none;
        /*color: white;*/
        min-width: 130px;
        cursor: pointer;
        border-radius: 3px;
        padding: 7px 14px;
        border: 0;
        background-color: inherit;
        text-align: left;
    }
    .menu-list button:hover {
        /*background-color: var(--menu-color);*/
        background-color: var(--main-selected-background);
        /*color: var(--menu-background);*/
    }
    .dropdown {
        /*display: inline-block;*/
        /*position: relative;*/
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 500;
    }
    .clickable {
        cursor: pointer;
    }
</style>
